module.exports = __webpack_public_path__ + "static/img/gh_02e7fbfd4fcc_430.1106abe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gh_02e7fbfd4fcc_430.jpg
// module id = JZxp
// module chunks = 1